import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { GuidelineRuleDto } from 'api/repositories/guidelineRules/guidelineRules.types';

export const MAX_LENGTH = 100;

export const MAX_STEP = 3;

export const GUIDELINE_RULE_ARRAY_GROUPS = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PROHIBITIONS,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PROHIBITIONS_BEAUTY,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.GUIDE_IMAGE,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.BRAND_LOGO,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.EMBLEM_OLIVEYOUNG,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.SUBTITLE_MIDDLE,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
];

export const GUIDELINE_RULE_TAG_GROUPS = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.AT_TAGS,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.HASH_TAGS,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.CO_AUTHOR,
];

export const GUIDELINE_RULE_NOT_ALLOWED_UNDEFINED_VALUE_GROUP_NAMES: GuidelineRuleDto['groupName'][] = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
];

export const BEAUTY_OUTPUT_GROUP_NAMES: GuidelineRuleDto['groupName'][] = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_PACKAGE,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_TEXTURE,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_COLOR,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_TRY,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_BEFORE_AFTER,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_SELFIE,
];

export const BEAUTY_ATTACHMENT_GROUP_NAMES: GuidelineRuleDto['groupName'][] = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.ATTACHMENT_RAW_VIDEO,
];

export const FASHION_VIDEO_OUTPUT_GROUP_NAMES: GuidelineRuleDto['groupName'][] = [
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_REQUESTS,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_REFERENCE,
  GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_REFERENCE_DESCRIPTION,
];
